module.exports = __webpack_public_path__ + "static/5-86ddb6b8573f874d80d7d5655399e857.jpg";